const createBulkSnapshots = require('./shipment-bulk-create-snapshots')
const {createShipmentParams, constructSupplierTree, parseAllocationSheet} = require('./utils/make-bulk-snapshot-from-sheet')

function bulkSnapshotsFromSheet (state, buffer, { isCnR = false, locationRoutes = {} } = {}) {
  const rows = parseAllocationSheet(buffer, { isCnR, locationRoutes })
  const rowsWithSuppliers = constructSupplierTree(rows)
  const params = createShipmentParams(rowsWithSuppliers, { isCnR })
  if (params.error) {
    return params
  }

  return createBulkSnapshots(state, params)
}

async function bulkSnapshotsFromCsv (state, rows, shipmentApi) {
  const rowsWithSuppliers = constructSupplierTree(rows)
  const params = createShipmentParams(rowsWithSuppliers, { isCnR: false, removePaymentType: true })
  if (params.error) {
    return params
  }
  const snapshotsWithPrices = await shipmentApi.decorateShipmentSnapshotsWithResolvedPrices(params)
  return createBulkSnapshots(state, snapshotsWithPrices)
}

module.exports = { bulkSnapshotsFromSheet, bulkSnapshotsFromCsv }
